import { createApp } from "vue";
import "animate.css";
import "@fontsource/nunito";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./translations";

createApp(App).use(store).use(router).use(i18n).mount("#app");
